import styled from "styled-components";
import { TextBold, Text } from "../typography/Texts";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { colors } from "@permisso/permisso-components";

interface MobileSectionHeaderProps {
  title: string;
  description: string;
}

export const MobileSectionHeader = ({ title, description }: MobileSectionHeaderProps) => {
  const { t } = useTranslations();
  return (
    <Container>
      <MobileHeader>{t(title)}</MobileHeader>
      <MobileDescription>{t(description)}</MobileDescription>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const MobileHeader = styled(TextBold)`
  font-size: 1.25rem;
`;

const MobileDescription = styled(Text)`
  font-size: 0.875rem;
  color: ${colors.grey700};
`;
